export function extractLayerBbox(xml, targetLayerName) {
  if (!xml || !targetLayerName) return null;

  const normalizedTarget = targetLayerName.includes(':')
    ? targetLayerName.split(':')[1]
    : targetLayerName;

  let found = null;

  for (const layerEl of xml.querySelectorAll('Layer')) {
    const nameEl = layerEl.querySelector(':scope > Name');
    if (!nameEl) continue;

    const name = nameEl.textContent.trim();
    if (name === targetLayerName || name === normalizedTarget) {
      found = layerEl;
      break;
    }
  }

  if (!found) {
    for (const layerEl of xml.querySelectorAll('Layer')) {
      if (
        layerEl.querySelector('BoundingBox[CRS="EPSG:4326"]') ||
        layerEl.querySelector('BoundingBox[SRS="EPSG:4326"]') ||
        layerEl.querySelector('LatLonBoundingBox') ||
        layerEl.querySelector('EX_GeographicBoundingBox')
      ) {
        found = layerEl;
        break;
      }
    }
  }

  if (!found) return null;

  const bboxEl =
    found.querySelector('BoundingBox[CRS="EPSG:4326"]') ||
    found.querySelector('BoundingBox[SRS="EPSG:4326"]');

  if (bboxEl) {
    return {
      minx: parseFloat(bboxEl.getAttribute('minx')),
      miny: parseFloat(bboxEl.getAttribute('miny')),
      maxx: parseFloat(bboxEl.getAttribute('maxx')),
      maxy: parseFloat(bboxEl.getAttribute('maxy')),
    };
  }

  const latLonBboxEl = found.querySelector('LatLonBoundingBox');
  if (latLonBboxEl) {
    return {
      minx: parseFloat(latLonBboxEl.getAttribute('minx')),
      miny: parseFloat(latLonBboxEl.getAttribute('miny')),
      maxx: parseFloat(latLonBboxEl.getAttribute('maxx')),
      maxy: parseFloat(latLonBboxEl.getAttribute('maxy')),
    };
  }

  const exGeoBboxEl = found.querySelector('EX_GeographicBoundingBox');
  if (exGeoBboxEl) {
    return {
      minx: parseFloat(exGeoBboxEl.querySelector('westBoundLongitude')?.textContent || '0'),
      miny: parseFloat(exGeoBboxEl.querySelector('southBoundLatitude')?.textContent || '0'),
      maxx: parseFloat(exGeoBboxEl.querySelector('eastBoundLongitude')?.textContent || '0'),
      maxy: parseFloat(exGeoBboxEl.querySelector('northBoundLatitude')?.textContent || '0'),
    };
  }

  return null;
}

export async function fetchWmsLayerBbox({ baseUrl, version, layers }) {
  if (!baseUrl || !layers) return null;

  const capUrl = `${baseUrl}?service=WMS&request=GetCapabilities&version=${version || '1.1.1'}`;
  const response = await fetch(`/api/wms-proxy?url=${encodeURIComponent(capUrl)}`);
  const xmlText = await response.text();
  const xml = new DOMParser().parseFromString(xmlText, 'text/xml');

  return extractLayerBbox(xml, layers);
}
